import { useTranslation } from "react-i18next"
import HasPermission, { CanViewCompanyLog } from "app/PermissionChecker"
import { useGetPlatformActivtyQuery } from "../api/platformAdminApiSlice"
import ActivityStats from "features/core/company/components/ActivityStats"
import React, { useEffect, useState } from "react"

function PlatformActivityStats() {
    const [t, i18n] = useTranslation("global")
    const canViewCompanyLog = HasPermission(CanViewCompanyLog)
    const [selectedDays, setSelectedDays] = useState(14);

    const {
        data: statsData,
        isFetching: statsIsFetching,
        isSuccess: statsIsSuccess,
        isLoading: statsIsLoading,
        isError: statsIsError,
        error: statsError,
        refetch: statsRefetch,
    } = useGetPlatformActivtyQuery(selectedDays)

    // Refetch automatico su cambio filtro
    useEffect(() => {
        statsRefetch(selectedDays);
    }, [selectedDays]);

    let content

    if (statsIsSuccess) {
        content = <ActivityStats data={statsData} isLoading={statsIsFetching} onChangeDaysNumber={setSelectedDays} />
    }
    return content
}

export default PlatformActivityStats